import { FC } from 'react';
import { CalendarResponseDto } from '@/features/calendar/types/calendar-dto';
import MoneyReceiveCircleIcon from '@/components/icons/MoneyReceiveCircleIcon';
import { Skeleton } from '@/components/ui/skeleton';
import CalendarSearch from '@/features/calendar/components/CalendarSearch';
import { cn } from '@/lib/utils';
import CurrencyValue from '@/features/finances/components/CurrencyValue';
import { DateTimeHelper } from '@/utils/dateTimeHelper';

type Props = {
    selectedDate: Date;
    searchText: string;
    setSearchText: (text: string) => void;
    headerWidth?: string;
} & CalendarResponseDto;

const CalendarDailyHeader: FC<Props> = ({
    selectedDate,
    searchText,
    setSearchText,
    apartments,
    headerWidth = 82,
}) => {
    return (
        <div className="sticky left-0 z-10">
            <table className={cn(`w-${headerWidth} border-none`)}>
                <thead>
                    <tr>
                        <th className="p-0 bg-popover-10 border border-popover-100 border-t-0 first:border-l-0">
                            <CalendarSearch value={searchText} onChange={setSearchText} />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {!!apartments?.length &&
                        apartments.map((apartment) => {
                            const hideApartmentName =
                                apartment.documents?.some((doc) =>
                                    DateTimeHelper.shouldRenderBookingInMonth(
                                        selectedDate,
                                        doc.checkInDate,
                                        doc.checkOutDate,
                                    ),
                                );

                                return (
                                <tr key={`header-${apartment.apartmentId}`}>
                                    {hideApartmentName && (
                                        <td className="h-23 p-0 bg-popover-10 border border-popover-100 border-l-0 last:border-b-0 select-none">
                                            <div className="px-6 flex items-center gap-4">
                                                <Skeleton className="size-11 bg-popover-600 rounded-semi-xl" />
                                                <div className="flex flex-col gap-0.5">
                                                    <span className="text-base font-medium">
                                                        {apartment.apartmentName}
                                                    </span>
                                                    <div className="flex items-center gap-1">
                                                        <MoneyReceiveCircleIcon />
                                                        <span className="text-sm">
                                                            <CurrencyValue
                                                                value={apartment.monthTotalAmount}
                                                                asset="calendar"
                                                            />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                </tbody>
            </table>
        </div>
    );
};

export default CalendarDailyHeader;
